import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import UploadAdCreativeButton from '../../../pages/RightsSummary/DigitalRight/UploadAdForms/UploadAdCreativeButton'
import SkeletonForm from '../../../components/Form/Skeleton'
import FormDrawerWrapper from '../../../features/components/FormDrawerWrapper'
import UploadGamAdCreativeForm from './UploadGamAdCreativeForm'

import { ReactComponent as GoogleAdManagerIcon } from '../../../assets/logos/google-ad-manager-icon.svg'

import { useFetchLineItemsHandler } from './useFetchLineItemsHandler'
import useManageDrawer from '../../../hooks/formHooks/useManageDrawer'

import { clearRightUploadAdData } from '../../../modules/actions/rights'
import { closeForm } from '../../../modules/actions/forms'
import { clearLineItems } from '../../../modules/actions/lineItems'
import { rightWasLoadedSelector } from '../../../modules/selectors/rights'
import { lineItemsWasLoadedSelector } from '../../../modules/selectors/lineItems'

import { UPLOAD_GAM_AD_CREATIVE } from '../../../constants/forms'
import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../constants/selectLists/platformList'

// const initialRedirectionParams = {
//   [ROUTE_PARAMS.campaignId]: '',
//   [ROUTE_PARAMS.lineItemId]: ''
// }

const UploadGamAdCreative = ({ hasNotFetchedCampaigns, rightCampaignsToLoadIds }) => {
  const dispatch = useDispatch()

  // const [
  //   // redirectionParams,
  //   // setRedirectionParams
  // ] = useState(initialRedirectionParams)

  const rightWasLoaded = useSelector(rightWasLoadedSelector)
  const lineItemsWasLoaded = useSelector(lineItemsWasLoadedSelector)

  const clearHandler = useCallback(() => {
    if (lineItemsWasLoaded) {
      dispatch(clearLineItems())
    }
  }, [dispatch, lineItemsWasLoaded])

  const { isFormOpen } = useManageDrawer({
    formName: UPLOAD_GAM_AD_CREATIVE,
    onAfterFormClose: clearHandler
  })

  const isFormLoading = useMemo(() => {
    if (hasNotFetchedCampaigns) {
      return true
    } else if (rightCampaignsToLoadIds?.length) {
      return !lineItemsWasLoaded
    } else {
      return !rightWasLoaded
    }
  }, [rightWasLoaded, hasNotFetchedCampaigns, lineItemsWasLoaded, rightCampaignsToLoadIds])

  // const showSuccessModal = useRedirectFormDrawer(
  //   `${ROUTES.rightsSummary}?message=${MODAL_TYPE.rightFacebookAdUploaded}`
  // )

  // const redirectToAdSet = useCallback(() => {
  //   redirectTo(ROUTES.lineItemsSummary, {
  //     ...redirectionParams,
  //     [ROUTE_PARAMS.platform]: FACEBOOK_PLATFORM,
  //     [ROUTE_PARAMS.adAccount]: facebookAdAccountId
  //   })
  // }, [redirectionParams, facebookAdAccountId])
  //
  // const onModalCloseHandler = useCallback(() => {
  //   setRedirectionParams(initialRedirectionParams)
  // }, [])

  // const onSuccessAdFormSubmit = useCallback(
  //   params => {
  //     setRedirectionParams(params)
  //
  //     dispatch(clearAds())
  //     showSuccessModal()
  //   },
  //   [dispatch, showSuccessModal]
  // )

  const fetchLineItemsHandler = useFetchLineItemsHandler({
    rightCampaignsToLoadIds
  })

  useEffect(() => {
    if (isFormOpen && rightCampaignsToLoadIds?.length && !lineItemsWasLoaded) {
      fetchLineItemsHandler()
    }
  }, [isFormOpen, rightCampaignsToLoadIds, dispatch, fetchLineItemsHandler, lineItemsWasLoaded])

  useEffect(
    () => () => {
      dispatch(clearLineItems())
    },
    [dispatch]
  )

  const ButtonTrigger = useCallback(
    props => <UploadAdCreativeButton Icon={GoogleAdManagerIcon} text="Google Ad Manager" {...props} />,
    []
  )

  const onAfterFormCloseHandler = useCallback(() => {
    dispatch(clearRightUploadAdData(GOOGLE_AD_MANAGER_PLATFORM))
  }, [dispatch])

  return (
    <>
      <FormDrawerWrapper
        formName={UPLOAD_GAM_AD_CREATIVE}
        closeOnSubmit={false}
        OpenDrawerTrigger={ButtonTrigger}
        onAfterFormClose={onAfterFormCloseHandler}
        isFormLoading={isFormLoading}
        SkeletonFormComponent={SkeletonForm}
      >
        {/*// todo redirect to line item summary page after ad creation onSuccessSubmit*/}
        <UploadGamAdCreativeForm
          rightCampaignsToLoadIds={rightCampaignsToLoadIds}
          onSuccessSubmit={() => dispatch(closeForm())}
        />
      </FormDrawerWrapper>
      {/*todo PBR-1310 Implement success modal*/}
      {/*<UploadAdCreativeSuccessModal onModalClose={onModalCloseHandler} onGoToAdSet={redirectToAdSet} />*/}
    </>
  )
}

export default UploadGamAdCreative
